import { Environment } from "@environments/environment.interface";
import { appVersion } from "./version";

export const environment: Environment = {
  production: true,
  appVersion,
  appleStoreUrl: "https://apps.apple.com/us/app/rocket-closet-ski/id1581645814",
  androidStoreUrl: "https://play.google.com/store/apps/details?id=com.rocketcloset.app",
  stripeKey:
    "pk_live_51IA11DCajej8Q89wqIzEjGBXrHagfs5fNeM1brvea4cMgBcvbvpxIyeWafnYaSoF29g3UwxCOTp1F254bIR29Acb00ePDHlp9m",
  phoneNumber: "+19707439996",
  phoneNumberDisplay: "+1 (970) 743-9996",
  firebase: {
    apiKey: "AIzaSyCd9NMJXt18AKyPVMo3kMcz669XnpLgYyI",
    authDomain: "clothes-daa4b.firebaseapp.com",
    databaseURL: "https://clothes-daa4b.firebaseio.com",
    projectId: "clothes-daa4b",
    storageBucket: "clothes-daa4b.appspot.com",
    messagingSenderId: "949061229597",
    appId: "1:949061229597:web:6a57b376a9737e85c03af4",
  },
  collections: {
    appVersions: "app_versions",
    clothes_properties: "clothes_properties",
    driver: "drivers",
    items: "items",
    maintenance: "maintenance",
    orders: "orders",
    order_reviews: "order_reviews",
    packlists: "packlists",
    pendingOrders: "pending-orders",
    referrals: "referrals",
    subscriptions: "subscriptions",
    users: "users",
  },
  endpoints: {
    backendDomain: new URL("https://rc-backend-prod-949061229597.us-central1.run.app"),
    deletePaymentMethod: new URL("https://us-central1-clothes-daa4b.cloudfunctions.net/payment-deletePaymentMethod"),
    frontendDomain: new URL("https://app.rocketcloset.com"),
    getPaymentHistory: new URL("https://us-central1-clothes-daa4b.cloudfunctions.net/payment-getPaymentHistory"),
    getSubscriptions: new URL("https://us-central1-clothes-daa4b.cloudfunctions.net/stripe-getSubscriptions"),
    getSubscriptionsForAdmin: new URL(
      "https://us-central1-clothes-daa4b.cloudfunctions.net/subscription-getSubscriptions",
    ),
    getWallet: new URL("https://us-central1-clothes-daa4b.cloudfunctions.net/stripe-getWallet"),
    orderDeletionRequest: new URL(
      "https://us-central1-clothes-daa4b.cloudfunctions.net/notifications-orderDeletionRequest",
    ),
    traceUserVersion: new URL("https://us-central1-clothes-daa4b.cloudfunctions.net/tracing-traceUserVersion"),
  },
};
